import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: null, // optional Mã tự sinh
    duyet: // optional Thông tin duyệt
    {
        duoc_duyet: null, // required Cho biết điểm đến đã được duyệt hay chưa
        thoi_diem_duoc_duyet: null, // optional Cho biết thời điểm điểm đến đã được duyệt
        nguoi_duyet_id: null, // optional Mã người duyệt
    },
    thong_tin_chung: // required Thông tin điểm đến
    {
        ten: null, // required Tên điểm đến
        anh: null, // optional Mã ảnh đại diện user
        dia_chi: // optional Thông tin địa chỉ
        {
            quoc_gia: null, // optional Quốc gia
            quoc_tich_id: null, // optional Mã quốc tịch
            tinh: null, // optional Tên tỉnh
            tinh_id: null, // optional Mã tỉnh
            huyen: null, // optional Tên huyện
            huyen_id: null, // optional Mã huyện
            xa: null, // optional Tên xa
            xa_id: null, // optional Mã xã
            dia_chi: null, // optional Địa chỉ giao dịch
            kinh_do: null, // optional Kinh độ
            vi_do: null, // optional Vĩ độ
        },

        nguoi_dai_dien: // optional Thông tin người đại diện
        {
            ho_ten: null, // optional Họ và tên
            chuc_vu: null, // optional Chức vụ
            ngay_sinh: null, // optional Ngày sinh
            so_giay_to: null, // optional Số CMT/ Căn cước/ Hộ chiếu
            gioi_tinh: null, // optional Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
            dia_chi: null, // optional Địa chỉ
            dien_thoai: null, // optional Điện thoại
            email: null, // optional Email
        }
    },
    nguoi_tao_id: null, // required Mã người tạo
    thoi_diem_tao: null, // required Thời điểm tạo
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.validForm = {
    'thong_tin_chung.ten': [ValidService.required],
    'thong_tin_chung.dia_chi.tinh': [ValidService.required],
    'thong_tin_chung.dia_chi.huyen': [ValidService.required],
    'thong_tin_chung.dia_chi.xa': [ValidService.required],
    'thong_tin_chung.dia_chi.dia_chi': [ValidService.required],
    'thong_tin_chung.nguoi_dai_dien.ho_ten': [ValidService.required],
    'thong_tin_chung.nguoi_dai_dien.chuc_vu': [ValidService.required],
    'thong_tin_chung.nguoi_dai_dien.dien_thoai': [ValidService.required, ValidService.checkPhone],
    'thong_tin_chung.nguoi_dai_dien.so_giay_to': [ValidService.required],
    'thong_tin_chung.anh': [ValidService.required],

}

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "du_lieu_khai_bao.user_ten": "", //:regex:, $vn_text=Viêt nam
            'duyet.duoc_duyet': '',
            'du_lieu_khai_bao.user_account': ''
        },
        valid: {
            "du_lieu_khai_bao.user_ten": [], //:regex:, $vn_text=Viêt nam
            'duyet.duoc_duyet': [],
            'du_lieu_khai_bao.user_account': []
        },
        operator: {
            "du_lieu_khai_bao.user_ten": ":regex_i:", //:regex:, $vn_text=Viêt nam
            'duyet.duoc_duyet': '',
            'du_lieu_khai_bao.user_account': ''
        }
    }
};

export default model;
